import { composeIO } from 'react-compose-io'
import { cabecalhoDebitosIO } from './CabecalhoDebitos.IO'
import { CabecalhoDebitosView } from './CabecalhoDebitos.View'

export const CabecalhoDebitos = composeIO(CabecalhoDebitosView, cabecalhoDebitosIO)
